import { render } from "./MenuManagement.vue?vue&type=template&id=5a7d6690"
import script from "./MenuManagement.vue?vue&type=script&lang=js"
export * from "./MenuManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__